import axios from "axios";
import { tiposOcorrencia } from "./SacService";

// ⚠️ IDEAL: Mover isso para variáveis de ambiente (.env) -> process.env.REACT_APP_OPENAI_KEY
const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

class IaService {
    
    async analisarCoerencia(textoObservacao, motivoSelecionado, listaItens) {
        // Validação básica
        if ((!textoObservacao || textoObservacao.length < 3) && listaItens.length === 0) return null;

        const endpoint = "https://api.openai.com/v1/chat/completions";

        // 1. Prepara o resumo limpo dos itens
        const resumoItensUsuario = listaItens.map(i => {
            const sub = i.submotivoSelecionado;
            const nomeMotivo = sub ? sub.label : "Nenhum motivo selecionado";
            return `- Item: ${i.nmMercadoria || i.descricao} | Tela Selecionada: ${motivoSelecionado} | Motivo: "${nomeMotivo}"`;
        }).join("\n");

        // 2. Transforma o objeto de regras (tiposOcorrencia) em texto para a IA estudar
        // Isso dá à IA o "Manual Completo" do sistema
        // 2. Mapeamento Rígido de Intenções (O segredo está aqui)
        const regrasDeClassificacao = `
        REGRA MESTRA 1 (FÍSICO/DANOS):
        - Palavras-chave: "Avaria", "Quebrado", "Vazando", "Vazou", "Defeito", "Estragado", "Molhado", "Amassado", "Recall", "Vencido", "Vencimento", "Diferença de preço".
        - AÇÃO OBRIGATÓRIA: Tela deve ser [DEVOLUCAO].
        - Se estiver em [SOLICITACAO] ou [SOBRA_MERCADORIA] -> INCONSISTENTE.

        REGRA MESTRA 2 (QUANTIDADE/LOGÍSTICA):
        - Palavras-chave: "Faltou", "Não veio", "Menos", "Sobrou", "Veio a mais", "Invertido", "Trocado", "Faltante", "Ressalva no canhoto", "Ressalva na nota", "Ressalva ao motorista".
        - AÇÃO OBRIGATÓRIA: Tela deve ser [SOBRA_MERCADORIA]. Obs.: A tela SOBRA_MERCADORIA contém os motivos de sobra e falta.
        - Caso o cliente informe que tenha feito ressalva, não devemos validar o motivo, é pra já estar correto.
        - Se estiver em [DEVOLUCAO] (exceto se mencionar avaria junto) ou [SOLICITACAO] -> INCONSISTENTE.

        REGRA MESTRA 3 (DOCUMENTAL/FINANCEIRO):
        - Palavras-chave: "Carta de correção", "Reembolso", "Minuta", "Comprovante", "Canhoto".
        - Aqui o cliente pode informar uma diferença de preço também, desde que o motivo seja Reembolso financeiro.
        - "Reembolso Financeiro": Aceita discussões sobre valores/preços errados (desde que não envolva devolução física do produto).
        - AÇÃO OBRIGATÓRIA: Tela deve ser [SOLICITACAO].
        - Se estiver em [DEVOLUCAO] ou [SOBRA_MERCADORIA] -> INCONSISTENTE.

        REGRA MESTRA 4 (OUTROS/PREGUIÇA):
        - Se o usuário selecionou o motivo "OUTROS" mas descreveu um problema claro (ex: "veio quebrado"), você DEVE sugerir o motivo específico (ex: "AVARIA").
        `;

        // 3. Prompt Direto e Estruturado
        const promptSistema = `
        Você é um CLASSIFICADOR DE OCORRÊNCIAS FARMACÊUTICAS. Sua função é detectar ERROS DE CATEGORIZAÇÃO.
        Não seja educado, seja lógico.

        === TABELA DE MOTIVOS VÁLIDOS DO SISTEMA ===
        ${JSON.stringify(tiposOcorrencia)}

        === REGRAS DE VALIDAÇÃO ===
        ${regrasDeClassificacao}

        === DADOS DA ANÁLISE ===
        Texto do Usuário: "${textoObservacao}"
        Itens Selecionados:
        ${resumoItensUsuario}

        === SEU OBJETIVO ===
        1. Identifique a "INTENÇÃO REAL" baseada no texto da observação (Texto do Usuário) e regras acima. Seja criterioso, não podemos errar aqui, devemos interpretar corretamente a intenção do cliente dentro da observação com o que ele está selecionando.
        2. Compare a "INTENÇÃO REAL" com a "TELA SELECIONADA" (${motivoSelecionado}).
        3. Se forem incompatíveis, retorne "inconsistente": true.
        
        Exemplo de erro comum: Usuário seleciona "SOLICITACAO -> CARTA DE CORREÇÃO" mas escreve "Vidro quebrado". Isso é inconsistente. O correto seria "DEVOLUCAO -> AVARIA".
        Exemplo de outro erro comum: Usuário seleciona "DEVOLUCAO -> OUTROS" mas escreve "Recall" ou "Recolhimento". Isso é incosistente. O correto seria "DEVOLUCAO -> RECALL".

        Retorne APENAS um JSON neste formato:
        {
            "inconsistente": boolean,
            "mensagemCurta": "Explicação direta do erro para o usuário (máx 1 frase).",
            "caminhoCorretoCodigo": "DEVOLUCAO" | "SOBRA_MERCADORIA" | "SOLICITACAO",
            "motivoEspecificoSugestao": "LABEL DO SUBMOTIVO SUGERIDO (ex: AVARIA, FALTA DE MERCADORIA)" | null,
            "itensSuspeitos": ["Nome do produto errado"]
        }
        `;

        try {
            const response = await axios.post(
                endpoint,
                {
                    model: "gpt-4o", // Rápido e suficiente para classificação lógica
                    messages: [
                        { role: "system", content: "Você responde apenas em JSON válido." },
                        { role: "user", content: promptSistema }
                    ],
                    temperature: 0.1, // Quase zero para evitar alucinação criativa
                    response_format: { type: "json_object" }
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${OPENAI_API_KEY}` // Use variáveis de ambiente!
                    }
                }
            );

            const resultado = JSON.parse(response.data.choices[0].message.content);
            
            console.log("🔍 IA Check:", {
                texto: textoObservacao,
                telaAtual: motivoSelecionado,
                resultadoIA: resultado
            });

            return resultado;

        } catch (error) {
            console.error("IA Error:", error);
            return null;
        }
    }
}

export default new IaService();